import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, {
  Controller,
  Lazy,
  Mousewheel,
  Navigation,
  Pagination,
  Virtual
} from 'swiper/core'
import { SwiperOptions } from 'swiper'
import Image from 'next/legacy/image'
import styles from './_mostPopularSongs.module.scss'
import { isMobile } from '../../../utils/deviceDetection'
import { t } from '../../../utils'
import { joinedArtistsStr } from '../../../utils/songs/artists'

import classNames from 'classnames'
import { storeSongPath } from '../../../utils/routeHelpers'
import Link from 'next/link'
import { Song } from '../../../__generated__/graphql'

SwiperCore.use([Pagination, Navigation, Mousewheel, Lazy, Controller, Virtual])

const MostPopularSongs: React.FC<{ songs: Song[] }> = ({
  songs: mostPopularSongs
}) => {
  if (!mostPopularSongs) return <></>

  const params: SwiperOptions = {
    slidesPerView: 2,
    slidesPerGroup: 1,
    spaceBetween: 25,
    navigation: true,
    mousewheel: !isMobile()
      ? {
          forceToAxis: true
        }
      : false,
    watchSlidesVisibility: true,
    // Disable preloading of all images
    preloadImages: false,
    lazy: true,
    freeMode: true,
    breakpoints: {
      319: {
        slidesPerView: 2,
        slidesPerGroup: 1,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2,
        slidesPerGroup: 1,
        spaceBetween: 25
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 2,
        spaceBetween: 25
      }
    }
  }

  const songs = mostPopularSongs.map((song, index) => {
    return (
      <SwiperSlide key={song.id} virtualIndex={index}>
        <article className={styles.songSlide}>
          <a href={storeSongPath(song)}>
            <figure>
              <div className={classNames(styles.imgContainer)}>
                <Image
                  src={song.album.cover.medium}
                  alt={song.title}
                  quality={50}
                  width={205}
                  height={205}
                  layout="responsive"
                  sizes="(max-width: 256px) 66px,
                        (max-width: 384px) 85px,
                        (max-width: 769px) 210px,
                        (max-width: 1024px) 256px,
                        (max-width: 1216px) 240px,
                        (max-width: 1408px) 153px,
                        205px"
                />
              </div>
              <figcaption>
                <div className={styles.songTitle}>
                  <strong>{song.title}</strong>
                </div>
                <div className={styles.artistName}>
                  {joinedArtistsStr(song.artists)}
                </div>
              </figcaption>
            </figure>
          </a>
        </article>
      </SwiperSlide>
    )
  })

  return (
    <section className={`${styles.block} ${styles.trending} column`}>
      <Link href={'/store/songs'} prefetch={false}>
        <header className={styles.header}>
          <h2>{t('20 Most Popular Songs')}</h2>
          <div className={styles.moreLink}>{t('View All >')}</div>
        </header>
      </Link>

      <Swiper virtual {...params}>
        {songs}
      </Swiper>
    </section>
  )
}

export default MostPopularSongs
